<template>
  <div class="font-sans antialiased">
    <button v-show="!(isMobile && isChatOpen)" @click="toggleChat" aria-label="Abrir Agente IA"
      class="fixed z-50 bottom-[calc(1.25rem+env(safe-area-inset-bottom))] right-4 h-16 w-16 rounded-2xl shadow-[0_18px_60px_-20px_rgba(124,58,237,.65)] ring-1 ring-white/15 active:scale-95 transition-all grid place-items-center bg-gradient-to-br from-fuchsia-600 via-purple-600 to-indigo-600 text-white hover:brightness-[1.08]">
      <transition name="icon">
        <span v-if="!isChatOpen" key="open" class="material-symbols-outlined text-[32px]">auto_awesome</span>
        <span v-else key="close" class="material-symbols-outlined text-[32px]">close</span>
      </transition>
    </button>

    <transition name="dock">
      <section v-if="isChatOpen"
        :class="isMobile ? 'fixed inset-0 z-40 flex flex-col justify-end' : 'fixed bottom-0 left-1/2 -translate-x-1/2 z-40 w-full max-w-[760px] p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]'"
        aria-label="Agente IA" role="dialog" aria-modal="true">
        <div v-if="isMobile" class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="minimize"></div>

        <div
          :class="isMobile ? 'relative mx-auto w-full max-w-[760px] rounded-t-3xl overflow-hidden' : 'relative mx-auto w-full rounded-3xl overflow-hidden'">
          <div
            class="pointer-events-none absolute inset-0 bg-[conic-gradient(at_20%_0%,#7c3aed33,#22d3ee33,#a78bfa33,#ec489933,#7c3aed33)] opacity-40">
          </div>

          <div :style="isMobile ? 'max-height:86vh' : ''"
            class="relative backdrop-blur-2xl border border-white/10 ring-1 ring-black/5 dark:ring-white/10 shadow-[0_30px_70px_-35px_rgba(2,6,23,.65)] dark:shadow-[0_30px_70px_-35px_rgba(0,0,0,.75)] bg-white/85 dark:bg-slate-900/85"
            :class="isMobile ? 'rounded-t-3xl' : 'rounded-3xl'">
            <header
              class="flex items-center justify-between gap-3 px-5 py-4 border-b border-black/5 dark:border-white/10">
              <div class="flex items-center gap-3">
                <div
                  class="relative grid h-11 w-11 place-items-center rounded-2xl text-white ring-1 ring-white/15 shadow-md bg-gradient-to-br from-purple-600 to-indigo-600">
                  <span class="material-symbols-outlined text-[22px]">auto_awesome</span>
                  <span
                    class="absolute -right-1 -bottom-1 h-4 w-4 rounded-full bg-emerald-500 ring-2 ring-white dark:ring-slate-900"></span>
                </div>
                <div>
                  <h2 class="text-[15px] font-semibold tracking-tight text-slate-900 dark:text-slate-100">Agente IA</h2>
                  <p class="text-[12px] text-slate-500 dark:text-slate-400">Registre gastos, consulte saldo e peça
                    análises.</p>
                </div>
              </div>
              <div class="flex items-center gap-1.5">
                <button @click="minimize" aria-label="Minimizar"
                  class="grid h-9 w-9 place-items-center rounded-xl text-slate-500 hover:bg-black/5 dark:text-slate-300 dark:hover:bg-white/5">
                  <span class="material-symbols-outlined text-[20px]">expand_more</span>
                </button>
              </div>
            </header>

            <div class="px-4 pt-4 space-y-3 overflow-hidden"
              :class="isMobile ? 'max-h-[calc(86vh-140px)]' : 'max-h-96'">
              <div class="flex flex-wrap gap-2">
                <button v-for="c in chips" :key="c" @click="quickFill(c)"
                  class="rounded-full px-3 py-1.5 text-[12px] font-medium border border-black/5 dark:border-white/10 bg-white/75 dark:bg-white/5 text-slate-700 dark:text-slate-200 hover:border-purple-400/40 hover:bg-purple-50/70 dark:hover:bg-white/10 transition-colors">
                  {{ c }}
                </button>
              </div>

              <transition name="bubble">
                <div v-if="carregando || respostaIA"
                  class="relative w-full rounded-2xl border border-black/10 dark:border-white/10 bg-white/75 dark:bg-slate-900/75 backdrop-blur-xl p-4 shadow-xl overflow-y-auto"
                  :class="isMobile ? 'max-h-[calc(86vh-210px)]' : 'max-h-64'">
                  <button @click="clearAnswer" aria-label="Fechar resposta"
                    class="absolute right-2.5 top-2.5 grid h-7 w-7 place-items-center rounded-full text-slate-500 hover:bg-black/5 dark:text-slate-400 dark:hover:bg-white/5">
                    <span class="material-symbols-outlined text-[18px]">close</span>
                  </button>

                  <div v-if="carregando"
                    class="flex items-center justify-center gap-3 text-slate-600 dark:text-slate-300 py-2" role="status"
                    aria-live="polite">
                    <span class="material-symbols-outlined text-[22px] animate-spin-slow">cached</span>
                    <span class="font-medium text-sm">Analisando…</span>
                  </div>

                  <div v-else class="space-y-3 text-[13px] pr-8">
                    <div v-if="perguntaEnviada" class="opacity-85">
                      <h3 class="mb-1 text-[12px] font-semibold text-slate-700 dark:text-slate-200">Você perguntou</h3>
                      <p class="text-slate-600 dark:text-slate-300">{{ perguntaEnviada }}</p>
                    </div>
                    <hr v-if="perguntaEnviada" class="border-black/10 dark:border-white/10">

                    <div class="flex items-start gap-3">
                      <span v-if="isSuccess" class="material-symbols-outlined text-emerald-500">check_circle</span>
                      <span v-else-if="isError" class="material-symbols-outlined text-rose-500">error</span>
                      <span v-else class="material-symbols-outlined text-purple-500">auto_awesome</span>

                      <div class="flex-1">
                        <strong
                          class="block text-[12px] font-semibold text-purple-600 dark:text-purple-400 mb-1.5">Resposta
                          do Agente</strong>
                        <div
                          class="prose prose-sm dark:prose-invert max-w-none leading-relaxed text-slate-700 dark:text-slate-300"
                          :class="{ 'text-rose-600 dark:text-rose-400': isError }" v-html="formatarTexto(respostaIA)">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>

            <div class="p-4">
              <div class="relative group">
                <span
                  class="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 transition-colors group-focus-within:text-purple-500">auto_awesome</span>
                <input ref="inputRef" v-model="mensagem" @keyup.enter="enviar" :disabled="carregando" type="text"
                  inputmode="text" autocomplete="off" spellcheck="false"
                  placeholder="Ex.: gastei R$ 89,90 em mercado hoje"
                  class="w-full h-[52px] rounded-2xl pl-12 pr-16 text-sm text-slate-900 dark:text-slate-100 bg-white/90 dark:bg-slate-900/90 backdrop-blur-xl border border-black/10 dark:border-white/10 shadow-lg focus:outline-none focus:ring-4 focus:ring-purple-400/30 focus:border-purple-500 transition-all disabled:opacity-60 disabled:cursor-not-allowed" />
                <button @click="enviar" :disabled="!mensagem.trim() || carregando" aria-label="Enviar pergunta"
                  class="absolute right-1.5 top-1/2 -translate-y-1/2 grid h-11 w-11 place-items-center rounded-xl text-white shadow-lg bg-gradient-to-br from-fuchsia-600 via-purple-600 to-indigo-600 ring-1 ring-white/15 hover:brightness-110 active:scale-95 transition-all disabled:opacity-60 disabled:cursor-not-allowed">
                  <span class="material-symbols-outlined text-[20px]">arrow_upward</span>
                </button>
              </div>

              <div class="mt-2 flex items-center justify-between">
                <div class="text-[11px] text-slate-500 dark:text-slate-400">Dica: use **negrito** e listas com •</div>
                <div class="hidden sm:flex items-center gap-1.5 text-[11px] text-slate-500 dark:text-slate-400">
                  <kbd class="rounded-md border border-black/10 px-1.5 py-0.5">⌘</kbd>
                  <span>+</span>
                  <kbd class="rounded-md border border-black/10 px-1.5 py-0.5">I</kbd>
                  <span>abrir/fechar</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import axios from 'axios'

const isChatOpen = ref(false)
const mensagem = ref('')
const perguntaEnviada = ref('')
const respostaIA = ref('')
const carregando = ref(false)
const isError = ref(false)
const isSuccess = ref(false)
const inputRef = ref(null)
const isMobile = ref(false)

const chips = [
  'Registrar gasto de mercado',
  'Quais os meus gastos desse mês?',
  'Meu saldo no banco',
  'Criar meta de economia R$ 300'
]

const API_BASE_URL = 'https://backend.controlease.com.br'
const API_ENDPOINT = `${API_BASE_URL}/api/agente/conversar`

function updateIsMobile() {
  isMobile.value = window.matchMedia('(max-width: 767.98px)').matches
}
onMounted(() => {
  updateIsMobile()
  window.addEventListener('resize', updateIsMobile)
  window.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'i') { e.preventDefault(); toggleChat() }
    if (e.key === 'Escape' && isChatOpen.value) minimize()
  })
})

function focusInput() { nextTick(() => inputRef.value?.focus()) }
function toggleChat() { isChatOpen.value = !isChatOpen.value; if (isChatOpen.value) focusInput() }
function minimize() { isChatOpen.value = false }
function quickFill(text) { mensagem.value = text; focusInput() }

function formatarTexto(texto) {
  if (!texto) return ''
  const money = s => s.replace(/(R\$\s?[\d.,]+)/g, '<strong class="font-semibold text-purple-600 dark:text-purple-400">$1</strong>')
  let html = texto
    .replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold text-slate-900 dark:text-white">$1</strong>')
    .replace(/`([^`]+)`/g, '<code class="px-1.5 py-0.5 rounded-md bg-slate-900/5 dark:bg-white/5 border border-black/5 dark:border-white/10 text-[12px]">$1</code>')
  return html.split('\n').map(line => {
    const t = line.trim()
    if (!t) return ''
    if (/^[-*•]\s+/.test(t)) return `<li class="flex items-start gap-2"><span class="material-symbols-outlined text-[18px] leading-5 text-purple-500">arrow_right</span><span>${money(t.replace(/^[-*•]\s+/, ''))}</span></li>`
    return `<p>${money(t)}</p>`
  }).join('')
}

async function enviar() {
  const msg = mensagem.value.trim()
  if (!msg || carregando.value) return

  const token = localStorage.getItem('token')
  perguntaEnviada.value = msg
  mensagem.value = ''
  carregando.value = true
  respostaIA.value = ''
  isError.value = false
  isSuccess.value = false
  if (!isChatOpen.value) isChatOpen.value = true

  try {
    if (!token) throw new Error('UNAUTH')
    const { data } = await axios.post(API_ENDPOINT, { mensagem: perguntaEnviada.value }, { headers: { Authorization: `Bearer ${token}` } })
    if (data && data.resposta) {
      respostaIA.value = data.resposta
      const ok = ['registrado', 'anotada', 'cadastrada', 'criada', 'adicionados', 'definido', 'sucesso', 'ok, o saldo']
      if (ok.some(w => data.resposta.toLowerCase().includes(w))) isSuccess.value = true
    } else throw new Error('EMPTY')
  } catch (e) {
    respostaIA.value = '⚠️ Você precisa estar logado para interagir com o agente.'
    isError.value = true
  } finally {
    carregando.value = false
    focusInput()
  }
}

function clearAnswer() {
  respostaIA.value = ''
  perguntaEnviada.value = ''
  isError.value = false
  isSuccess.value = false
  focusInput()
}
</script>

<style scoped>
.icon-enter-active,
.icon-leave-active {
  transition: opacity .15s ease, transform .15s ease
}

.icon-enter-from,
.icon-leave-to {
  opacity: 0;
  transform: scale(.9)
}

.dock-enter-active,
.dock-leave-active {
  transition: transform .4s cubic-bezier(.22, 1, .36, 1), opacity .25s ease
}

.dock-enter-from,
.dock-leave-to {
  transform: translateY(18px);
  opacity: 0
}

.bubble-enter-active,
.bubble-leave-active {
  transition: transform .35s cubic-bezier(.2, .8, .2, 1), opacity .25s ease
}

.bubble-enter-from,
.bubble-leave-to {
  transform: translateY(12px) scale(.98);
  opacity: 0
}

@keyframes spin-slow {
  to {
    transform: rotate(360deg)
  }
}

.animate-spin-slow {
  animation: spin-slow 1.5s linear infinite
}

.prose :where(p, ul, li) {
  margin: 0
}

.prose :where(p:not(:first-child), ul:not(:first-child)) {
  margin-top: .75rem
}

.prose :where(ul) {
  list-style: none;
  padding: 0
}

.prose :where(li:not(:first-child)) {
  margin-top: .5rem
}
</style>
